import React from "react";
import PropTypes from "prop-types";

const ModalSuccess = ({ className, color }) => (
  <svg
    className={className}
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.4999 0.083252C9.22992 0.083252 0.083252 9.22992 0.083252 20.4999C0.083252 31.7699 9.22992 40.9166 20.4999 40.9166C31.7699 40.9166 40.9166 31.7699 40.9166 20.4999C40.9166 9.22992 31.7699 0.083252 20.4999 0.083252ZM16.4166 30.7083L6.20825 20.4999L9.087 17.6212L16.4166 24.9303L31.9128 9.43409L34.7916 12.3333L16.4166 30.7083Z"
      fill={color}
    />
  </svg>
);

ModalSuccess.defaultProps = {
  color: "#8AC149",
  className: "",
};

ModalSuccess.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
};

export default ModalSuccess;
